<template>
  <button
    class="text-white call-me-now py-4 rounded-full flex items-center justify-center w-full"
    @click="$emit('call')"
  >
    <BaseIcon class="text-23 mr-6" icon="phone" />
    <TypeBody class="text-23 font-bold">Call Me Now</TypeBody>
  </button>
</template>

<script>
import { BaseIcon, TypeBody } from '@bambeehr/pollen';

export default {
  components: {
    BaseIcon,
    TypeBody,
  },
  setup() {},
};
</script>

<style scoped>
/* stylelint-disable */
.call-me-now {
  background: linear-gradient(103.15deg, #26d0d0 0%, #16a7a7 100%);
  box-shadow: 0px 20px 8px -16px rgba(34, 197, 197, 0.32);
}
/* stylelint-enable */
</style>
